import { StaticImageData } from "next/image";

import { MAX_WIDTH, mobileScreenType, tabletScreenType } from "@stadium/helpers/style";

import Multimedia from "@stadium/shared/src/components/shared/multimedia";

export interface ResponsiveImageProps {
  mobileSrc: string | StaticImageData;
  tabletSrc?: string | StaticImageData;
  desktopSrc: string | StaticImageData;
  alt: string;
  className?: string;
  priority?: boolean;
  fetchPriority?: "high" | "low" | "auto";
}

const resolveImageSrc = (image?: string | StaticImageData) =>
  typeof image === "string" ? image : image?.src || "";

const ResponsiveImage: React.FC<Readonly<ResponsiveImageProps>> = ({
  mobileSrc,
  tabletSrc,
  desktopSrc,
  alt,
  className,
  priority = false,
  fetchPriority,
}) => {
  // MAX_WIDTH values are inclusive upper bounds (e.g. "767px" for mobile).
  // For min-width queries we need +1px to avoid overlap at the boundary.
  const tabletMinWidth = `${Number.parseInt(MAX_WIDTH[mobileScreenType]) + 1}px`;
  const desktopMinWidth = `${Number.parseInt(MAX_WIDTH[tabletScreenType]) + 1}px`;

  return (
    <picture>
      {tabletSrc && (
        <source
          media={`(min-width: ${tabletMinWidth}) and (max-width: ${MAX_WIDTH[tabletScreenType]})`}
          srcSet={resolveImageSrc(tabletSrc)}
        />
      )}
      <source
        media={`(min-width: ${tabletSrc ? desktopMinWidth : tabletMinWidth})`}
        srcSet={resolveImageSrc(desktopSrc)}
      />
      <Multimedia
        type="image"
        src={resolveImageSrc(mobileSrc)}
        alt={alt}
        className={className}
        priority={priority}
        fetchPriority={fetchPriority}
      />
    </picture>
  );
};

export default ResponsiveImage;
